module.exports = __webpack_public_path__ + "media/videos/sea-9e9083a971205136fed396347e77c064.mp4";